export default __webpack_public_path__ + "static/media/spinner.a74b50f6.gif";